<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="newCritereRecherche!== undefined && newCritereRecherche!== null">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('compteTiers.filtres.datePiece')">
            <div class="columns is-vcentered" >
              <b-datepicker show-week-number
                            class="column"
                            v-model="newCritereRecherche.periode.dateDebut"
                            icon="calendar-today"
                            :editable="true"
                            position="is-bottom-right"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
              <span class="column is-1">{{$t('compteTiers.filtres.datePieceAu')}}</span>
              <b-datepicker show-week-number
                            class="column"
                            v-model="newCritereRecherche.periode.dateFin"
                            icon="calendar-today"
                            :editable="true"
                            position="is-bottom-left"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('compteTiers.filtres.types')"
                        :items="constantes.LISTE_TYPE_PIECE_VENTE"
                        v-model="typesSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('compteTiers.filtres.numeroPiece')">
            <b-input v-model="newCritereRecherche.numero">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('compteTiers.filtres.libelle')">
            <b-input v-model="newCritereRecherche.libelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('compteTiers.filtres.montantsDebit')">
            <div class="columns is-vcentered">
              <input-currency v-model="newCritereRecherche.debit.borneBasse"
                              class="column"
                              isNumber="true">
              </input-currency>
              <span class="column is-1">{{$t('compteTiers.filtres.montantsA')}}</span>
              <input-currency v-model="newCritereRecherche.debit.borneHaute"
                              class="column"
                              isNumber="true">
              </input-currency>
            </div>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('compteTiers.filtres.montantsCredit')">
            <div class="columns is-vcentered" >
              <input-currency v-model="newCritereRecherche.credit.borneBasse"
                              class="column"
                              isNumber="true">
              </input-currency>
              <span class="column is-1">{{$t('compteTiers.filtres.montantsA')}}</span>
              <input-currency v-model="newCritereRecherche.credit.borneHaute"
                              class="column"
                              isNumber="true">
              </input-currency>
            </div>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('compteTiers.filtres.etats')"
                        :items="constantes.LETTRAGE_ETAT"
                        v-model="etatLettrageSelected">
          </libelle-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { SET_CRITERE } from '@/store/modules/compteClient-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import genererCriteresRechercheCompteClient from '@/services/bodac/client/criteresRecherche/genererCriteresRechercheCompteClient';
import { LISTE_TYPE_PIECE_VENTE } from '@/configuration/mouvementClient/mouvementClientConf';
import { LETTRAGE_ETAT } from '@/configuration/lettrageConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

export default {
  name: 'filtreCompteTiers',
  props: {
    nameStore: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
      newCritereRecherche: null,
      constantes: {
        LISTE_TYPE_PIECE_VENTE,
        LETTRAGE_ETAT,
      },
      typesSelected: [],
      etatLettrageSelected: [],
    };
  },
  components: {
    libelleTagInput,
    errorMsgComponent,
    inputCurrency,
  },
  methods: {
    setCritereRecherche(criteres) {
      return this.$store.commit(`${this.nameStore}/${SET_CRITERE}`, criteres);
    },
    appliquerCritere() {
      this.errors = [];
      if (moment(this.newCritereRecherche.periode.dateDebut)
        .isAfter(this.newCritereRecherche.periode.dateFin)) {
        this.errors.push({
          message: 'compteTiers.filtres.errors.messageErrorDate',
        });
        return;
      }
      this.newCritereRecherche.types = this.typesSelected.map((typePiece) => {
        return typePiece.code;
      });
      this.newCritereRecherche.etats = this.etatLettrageSelected.map((etat) => {
        return etat.etat;
      });

      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche');
      this.$emit('toggleFiltre');
    },
    viderCritere() {
      this.newCritereRecherche = genererCriteresRechercheCompteClient();
      this.typesSelected = [];
      this.etatLettrageSelected = [];
    },
    initializeFiltre() {
      this.newCritereRecherche = cloneDeep(this.critereRecherche);
      if (this.newCritereRecherche.types) {
        this.typesSelected = this.constantes.LISTE_TYPE_PIECE_VENTE.filter((option) => {
          return this.newCritereRecherche.types.includes(option.code);
        });
      }
      if (this.newCritereRecherche.etats) {
        this.etatLettrageSelected = this.constantes.LETTRAGE_ETAT.filter((option) => {
          return this.newCritereRecherche.etats.includes(option.etat);
        });
      }
    },
  },
  computed: {
    critereRecherche() {
      return this.$store.getters[`${this.nameStore}/critereRecherche`];
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>
</style>
